import axios, { AxiosResponse } from "axios";
import { Dispatch } from "react";
import { AnyIfEmpty } from "react-redux";
import { GET_LOCATIONS_LIST_FAILURE, GET_LOCATIONS_LIST_REQUEST, GET_LOCATIONS_LIST_SUCCESS } from "../constants/auth.constant";


const getLocationListRequest = () => {
  return {
    type: GET_LOCATIONS_LIST_REQUEST
  }
}

const getLocationListSuccess = (data: AnyIfEmpty<object>) => {
  return {
    type: GET_LOCATIONS_LIST_SUCCESS,
    payload: data,
  };
}

const getLocationListFailure = (error: string) => {
  return {
    type: GET_LOCATIONS_LIST_FAILURE,
    payload: error
  }
}

export const getLocationList = () => {
  return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
    dispatch(getLocationListRequest());
    await axios
      .get('/locations/listing')
      .then((response: AxiosResponse) => {
        if (response?.data?.statusCode === 200) {
          dispatch(getLocationListSuccess(response.data?.locations || []))
        } else {
          dispatch(getLocationListFailure(response?.data?.message));
        }
      })
      .catch((err) => {
        dispatch(getLocationListFailure(err?.response?.data?.message));
      });
  };
};